import UtilityProgramEnrollmentManager from '@/app/features/utility-programs/UtilityProgramEnrollmentManager/UtilityProgramEnrollmentManager'
import UtilityProgramLegacyLearnMoreCard from '@/app/features/utility-programs/UtilityProgramLearnMoreDashboardView/UtilityProgramLegacyLearnMoreCard'
import useThermostatDeviceSectionViewModel from '../useThermostatDeviceSectionViewModel'
import { ProgramDisplay } from '@/hooks/useMultiProgramDisplay/useProgramDisplayType'
import { Card } from '@/components'
import DeviceProgramCards from '@/app/components/ProgramCards/DeviceProgramCards'
import MenuCard, { MenuCardItem } from '@/components/MenuCard'

export default function ThermostatProgramsTab({
  loading,
  settings,
  gridSupportSavings,
  navigateToGridSupport,
  thermostatId,
  programDisplayType,
}: ReturnType<typeof useThermostatDeviceSectionViewModel>) {
  return (
    <div className="flex flex-col w-full gap-4">
      {programDisplayType === ProgramDisplay.Legacy && (
        <>
          <UtilityProgramLegacyLearnMoreCard />
          <UtilityProgramEnrollmentManager
            deviceType="thermostat"
            deviceId={thermostatId}
            wrapper={Card}
          />
        </>
      )}
      {programDisplayType === ProgramDisplay.MultiProgram && (
        <DeviceProgramCards />
      )}
      <MenuCard icon="Zap" iconColor="#FBD242" title="Be a Watt Hero">
        <MenuCardItem
          id="thermostat-grid-support-menu-item"
          loading={loading}
          rightLabel={settings?.grid_support_enabled ? 'On' : 'Off'}
          label="Grid Support"
          sheetValue={gridSupportSavings ? `$${gridSupportSavings}` : undefined}
          onClick={navigateToGridSupport}
        />
      </MenuCard>
    </div>
  )
}
